var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/15a1d7ff995abe8e8849227b706ecef3.js').default;export default
        Object.assign({}, scope_0 )
    